import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock96 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_837_2328)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M70 26V28C70 15.85 60.15 6 48 6C35.85 6 26 15.85 26 28V48",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70 28V48",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54 64C54 60.69 51.31 58 48 58C44.69 58 42 60.69 42 64C42 65.74 42.75 67.29 43.94 68.39L42 80H54L52.06 68.39C53.24 67.29 54 65.74 54 64Z",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36 48V28C36 21.37 41.37 16 48 16C54.63 16 60 21.37 60 28V48",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18 84V48H78V84C78 87.31 75.31 90 72 90H24C20.69 90 18 87.31 18 84Z",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_837_2328",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgLock96;
